<template>
  <BreadCrumb PageTitle="Modifier Bon de Livraison" />
  <EditNote />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import EditNote from "@/components/Notes/Delivery/EditNote.vue";

export default defineComponent({
  name: "EditNotePage",
  components: { BreadCrumb, EditNote },
});
</script>
